













































import { Component, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import OpportunityLostReasonDto from '@/models/Opportunities/OpportunityLostReasonDto';
import UpdateOpportunityLostReasonRequest from '@/models/Opportunities/UpdateOpportunityLostReasonRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'OpportunityLostReasonEdit'
})
export default class extends GiganautVueDialog {

  public entity = new OpportunityLostReasonDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentOpportunityLostReason));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateOpportunityLostReasonRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    await AgencySettingsModule.editOpportunityLostReason(request)
    this.dialog = false;
  }
}
